import { useState, useEffect } from "react"

const useTime = () => {
  const getUTCAdjustedTime = hrs => {
    // Return time according to time zone
    let getUtcTime = /\d{2}:\d{2}/.exec(new Date().toUTCString())[0]
    let amPm
    getUtcTime = getUtcTime.replace(/^\d{2}/, x => {
      x = parseInt(x) + hrs
      if (x >= 24) x = x - 24
      if (x >= 12) amPm = `pm`
      else amPm = `am`
      if (x > 12) x = x - 12
      if (x < 10) return `0${x}`
      return x
    })
    return `${getUtcTime} ${amPm}`
  }

  const [time, setTime] = useState([
    getUTCAdjustedTime(2),
    getUTCAdjustedTime(8),
  ])

  useEffect(() => {
    const timeInterval = setInterval(() => {
      setTime([getUTCAdjustedTime(2), getUTCAdjustedTime(8)])
    }, 60000)
    return () => clearInterval(timeInterval)
  }, [])

  return time
}

export default useTime
